<template>
    <div class="phrase-wrap">
        <p
            ref="phrase"
            class="phrase-text"
            :class="{extended: isExtended}"
        >{{phrase}}</p>

        <p
            v-if="isShowing"
            class="more-btn"
            @click="showMore"
        >{{isExtended ? 'Show less' : 'Show more'}}</p>
    </div>
</template>

<script>
export default {
  mounted () {
    this.$nextTick(() => {
      this.phraseScrollHeight = this.$refs.phrase.scrollHeight
      this.phraseClientHeight = this.$refs.phrase.clientHeight
    })
  },

  props: {
    phrase: String
  },

  computed: {
    isShowing () {
      return this.phraseScrollHeight > this.phraseClientHeight
    }
  },

  data () {
    return {
      phraseScrollHeight: Number,
      phraseClientHeight: Number,
      isExtended: false

    }
  },

  methods: {
    showMore () {
      this.isExtended = !this.isExtended
    }
  }
}
</script>

<style lang="scss" scoped>
.phrase-wrap {
    margin-bottom: $sp-3;

    .phrase-text {
        margin: 0;
        font-size: 14px;
        line-height: 21px;
        color: $or-black-blue;
        transition: all .2s ease;

        max-height: 45px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;

        &.extended {
            -webkit-line-clamp: unset;
            max-height: 100%;
        }
    }

    .more-btn {
        margin: $sp-2 0 0;
        font-size: 12px;
        color: $or-blue;

        &:hover {
            cursor: pointer;
        }
    }
}
</style>
